module.exports = __webpack_public_path__ + "img/theme6.ec1151a9.png";